<template>
    <FilePond
        name="file"
        ref="pond"
        label-idle="Прикрепить файлы. Нажмите или перетащите их в это поле"
        allow-multiple="true"
        max-files="5"
        :server="server"
        @processfile="processfile"
        @removefile="removefile(true)"/>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import 'filepond/dist/filepond.min.css';
import vueFilePond from 'vue-filepond';
const FilePond = vueFilePond();
export default Vue.extend({
    props: {
        files: Array,
    },
    data() {
        return {
            server: {
                process: {
                    url: axios.defaults.baseURL + '/attachments',
                    revert: null,
                    method: 'POST',
                    withCredentials: false,
                    timeout: 10000,
                    onload: null,
                    onerror: null,
                    ondata: null,
                },
            },
        };
    },
    methods: {
        processfile(error, file) {
            this.files.push(JSON.parse(file.serverId));
        },
        removefile(error, file, manual=false) {
            if (manual) {
                var f = JSON.parse(file.serverId);
                var ind = -1;
                axios.delete(`/attachments/${f.id}`)
                    .then(() => {
                        for (var i = 0; i < this.files.length; i++)
                            if (this.files[i].id == f.id)
                                ind = i
                        this.files.splice(ind, 1);
                    });
            }
        },
        clear() {
            this.$refs.pond.removeFiles(this.$refs.pond.getFiles());
        },
    },
    components: {
        FilePond,
    },
});
</script>

<style></style>
